import(/* webpackMode: "eager" */ "/vercel/path0/packages/halo-query/app/error.tsx");
